import { useParams, Link } from 'react-router-dom';
import { useMemo } from 'react';
import ScrollToTop from '@/components/base/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { VideoCard } from '@/pages/home/components/VideoGrid';
import { videos } from '@/mocks/videos';
import { categories, categoryDetails } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'dianying';
  const catDetail = categoryDetails[currentSlug] || categoryDetails.dianying;

  const filteredVideos = useMemo(() => {
    return videos.filter((v) => v.category === currentSlug);
  }, [currentSlug]);

  const breadcrumbItems = [
    { label: '首页', path: '/' },
    { label: catDetail.name },
  ];

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-20">
        <div className="container-custom py-6">
          <Breadcrumb items={breadcrumbItems} />
        </div>

        <section className="py-8">
          <div className="container-custom">
            <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-3">
              {catDetail.name}
            </h1>
            <p className="text-sm text-foreground-500 mb-8 max-w-2xl">
              {catDetail.description}
            </p>

            <div className="flex items-center gap-2 mb-10 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer flex items-center gap-2 ${
                    currentSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredVideos.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5" data-product-shop>
                {filteredVideos.map((video) => (
                  <VideoCard key={video.id} video={video} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-film-line text-4xl text-foreground-300"></i>
                </div>
                <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}